
<div class="mail-frame" v-if="mail">
    <div
        class="lm-border mail-header"
    >
        <div class="mail-addr">
            <div class="label primary--text" :style="labelcolor">Von:</div>
            <div class="data mail-receiver" v-if="from"> {{ from }}</div>
        </div>
        <div class="mail-addr">
            <div class="label primary--text" :style="labelcolor">An:</div>
            <div class="data mail-receiver" v-for="(adress, index) in mail.to" :key="index"> {{ adress.email }};</div>
        </div>
        <div class="mail-addr">
            <div class="label primary--text" :style="labelcolor">Cc:</div>
            <div class="data mail-receiver" v-for="(adress, index) in mail.cc" :key="index"> {{ adress.email }};</div>
        </div>
        <div class="mail-addr">
            <div class="label primary--text" :style="labelcolor">Betreff:</div>
            <div class="mail-subject">{{ mail.subject }}</div>
        </div>
    </div>

    <div class="mail-attachment-list" v-if="mail.attachments && mail.attachments.length > 0">
        <div v-for="(attachment, index) in mail.attachments" :key="index" class="mail-attachment" style="display: flex">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind = "attrs"
                        v-on   = "on"
                        style  = "display: flex; width: 100%"
                    >
                        <p-dms-icon
                            :icon="icon(attachment)" style="margin-top: 2px; padding-right: 4px;" />
                        <div style=" overflow: hidden; white-space: nowrap; text-overflow: ellipsis; max-width: calc(100% - 25px)">{{ attachment.name }}</div>
                    </div>
                </template>

                <div style="display: flex">
                    <p-dms-icon
                        :icon="icon(attachment)"
                        style="margin-top: 2px; padding-right: 4px;"
                    />
                    <div>
                        {{ attachment.name }}
                    </div>
                </div>
            </v-tooltip>
        </div>
    </div>

    <div class  = "lm-border mail-body">
        <div v-html="body">
        </div>
    </div>
</div>
